var React = require('react');

function TsInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #2506fe;\n      }\n    ")),React.createElement("path",{"id":"Ts.inline","className":"cls-1","d":"M6,6V90.7H90.7V6ZM55.172,50.7H44.138V83.075H37.08V50.7H26.163V44.726H55.172ZM67.853,83.64a22.163,22.163,0,0,1-10.376-2.353L59.03,75.5a19.5,19.5,0,0,0,9.27,2.353c4.47,0,7.058-2.094,7.058-5.223s-1.929-4.705-6.8-6.376C62.23,64.018,58.184,60.63,58.184,55.125c0-6.282,5.247-11.011,13.575-11.011a20.374,20.374,0,0,1,9.2,1.906l-1.67,5.647a16.469,16.469,0,0,0-7.67-1.835c-4.447,0-6.329,2.353-6.329,4.705,0,2.941,2.212,4.329,7.317,6.282,6.682,2.541,9.881,5.882,9.881,11.387C82.393,78.323,77.735,83.64,67.853,83.64Z","transform":"translate(-6 -6)","key":1})]);
}

TsInline.defaultProps = {"className":"icon","viewBox":"0 0 84.698 84.698"};

module.exports = TsInline;

TsInline.default = TsInline;
